import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const DialogConfirmarCaixa = ({ visible, onHide, onConfirm }) => {
  return (
    <Dialog
      visible={visible}
      style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
      onHide={onHide}
      draggable={false}
      closable={false}
      header={null}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
          padding: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "25px",
            height: "25px",
            borderRadius: "50%",
            color: "#B83732",
            fontSize: "2.2rem",
          }}
        >
          <i className="pi pi-shopping-cart" style={{ fontSize: "2.5rem" }}></i>
        </div>
        <p
          style={{
            textAlign: "center",
            fontSize: "1rem",
            margin: 0,
            color: "#374151",
          }}
        >
          Deseja realizar o fechamento no CAIXA?
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            width: "100%",
          }}
        >
          <Button
            label="NÃO"
            icon="pi pi-times"
            onClick={onHide}
            className="p-button-outlined p-button-sm"
            style={{
              outline: "none",
              boxShadow: "none",
              padding: "8px 24px",
              minWidth: "100px",
              borderColor: "#e2e8f0",
              color: "#718096",
              fontWeight: "500",
              fontSize: "0.875rem",
              borderRadius: "8px",
            }}
          />
          <Button
            label="SIM"
            icon="pi pi-check"
            onClick={onConfirm}
            className="p-button-success p-button-sm"
            style={{
              outline: "none",
              boxShadow: "none",
              padding: "8px 24px",
              minWidth: "100px",
              fontWeight: "500",
              fontSize: "0.875rem",
              borderRadius: "8px",
            }}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default DialogConfirmarCaixa;